<template>
  <v-container class="not-found" fluid>
    <div class="not-found__card">
      <v-icon class="not-found__icon" size="48"
        >mdi-map-marker-question-outline</v-icon
      >
      <h1 class="not-found__title">Page not found</h1>
      <p class="not-found__text">
        There is no page at <span class="not-found__path">{{ path }}</span
        >. It may have moved, or the link may be mistyped.
      </p>
      <div class="not-found__actions">
        <v-btn color="primary" depressed large to="/">
          Go to {{ productName }}
        </v-btn>
        <v-btn v-if="canGoBack" text large @click="$router.back()">
          <v-icon left>mdi-arrow-left</v-icon>
          Go back
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
// The catch-all route (createBaseRoutes): an unknown URL gets this page inside the
// app shell, with a way home, instead of an empty shell.
export default {
  name: "NotFoundView",
  computed: {
    productName() {
      return (
        (this.$config &&
          (this.$config.productName || this.$config.PRODUCT_NAME)) ||
        "the app"
      );
    },
    path() {
      return this.$route.fullPath;
    },
    canGoBack() {
      return window.history.length > 1;
    }
  }
};
</script>

<style scoped>
.not-found {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}
.not-found__card {
  max-width: 520px;
  text-align: center;
}
.not-found__icon {
  color: var(--accent) !important;
  margin-bottom: 12px;
}
.not-found__title {
  color: var(--text-heading);
  font-size: 2rem;
  line-height: 1.2;
  margin-bottom: 12px;
}
.not-found__text {
  color: var(--text-secondary);
  font-size: var(--font-size-base);
  margin-bottom: 24px;
}
.not-found__path {
  color: var(--text-primary);
  word-break: break-all;
}
.not-found__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}
</style>
